import { render, staticRenderFns } from "./124.vue?vue&type=template&id=555beef6&scoped=true&"
var script = {}
import style0 from "./124.vue?vue&type=style&index=0&id=555beef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555beef6",
  null
  
)

export default component.exports